import type z from 'zod/v4'
import { index, integer, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

export const Subject = pgTable(
  'subject',
  {
    id: uuid().notNull().primaryKey(),
    name: text().notNull(),
    description: text(),
    order: integer().notNull(),
    legacyCategoryId: integer(),
    legacyNeonTagId: uuid(),
    updatedAt: timestamp({ mode: 'date', withTimezone: true, precision: 3 }).notNull(),
    createdAt: timestamp({ mode: 'date', withTimezone: true, precision: 3 }).notNull(),
  },
  (columns) => [
    index('subject_name_idx').on(columns.name),
    index('subject_updated_at_idx').on(columns.updatedAt),
    index('subject_created_at_idx').on(columns.createdAt),
  ],
)

export const InsertSubjectSchema = createInsertSchema(Subject)
export const UpdateSubjectSchema = createUpdateSchema(Subject)
  .omit({ id: true, legacyCategoryId: true, legacyNeonTagId: true })
  .partial()
export const SelectSubjectSchema = createSelectSchema(Subject)

export type InsertSubject = typeof Subject.$inferInsert
export type UpdateSubject = z.infer<typeof UpdateSubjectSchema>
export type SelectSubject = typeof Subject.$inferSelect
